'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clientLibrary = require('@seneca/client-library');

var _errorMapping = require('./errorMapping');

var _errorMapping2 = _interopRequireDefault(_errorMapping);

var _NotFoundError = require('./errors/NotFoundError');

var _NotFoundError2 = _interopRequireDefault(_NotFoundError);

var _tagType = require('./constants/tagType');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * TagsServiceClient
 * @param {Object} options options object input data and dependency injection
 * @param {Object} options.fetch change fetch method from whatwg-fetch (optional, default: whatwg-fetch)
 * @param {string} options.protocol the http protocol of the service endpoint
 * @param {string} options.host the host of the service endpoint
 * @param {string} options.path the path of the service endpoint (optional)
 * @param {number} options.retries the number of times the client should retry on network error / service error (optional, default: 3)
 * @param {number} options.delayInSecs the delay between retries (optional, default: 2)
 * @param {Object} options.credentials identifiers and secrets required to hit protected endpoints (optional)
 * @param {string} options.region states the region of the service for signing (optional, default: eu-west-1)
 * @param {RequestMaker} options.requestMaker for overriding request making logic (optional, default: RequestMaker)
 * @throws {UrlConstructionError} when either options.protocol or options.host is missing
 */


var TagsServiceClient =
/*#__PURE__*/
function (_clientLibrary$Client) {
  _inherits(TagsServiceClient, _clientLibrary$Client);

  function TagsServiceClient(fetch, options) {
    _classCallCheck(this, TagsServiceClient);

    return _possibleConstructorReturn(this, _getPrototypeOf(TagsServiceClient).call(this, fetch, options));
  }
  /**
   * Creates a  new tag
   * @param {string} body.text text of tag
   * @param {string} body.parentId Id of category parent of tag
   * @param {string} body.description optional descriptive body
   * @throws {RequestLimitExceeded} when the max number of retries has been hit
   * @returns {Promise<UserSubscription>} the user subscription object
   */


  _createClass(TagsServiceClient, [{
    key: "createTag",
    value: function () {
      var _createTag = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(tag) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (tag.text) {
                  _context.next = 2;
                  break;
                }

                throw new _clientLibrary.MissingParamError('text');

              case 2:
                if (tag.parentId) {
                  _context.next = 4;
                  break;
                }

                throw new _clientLibrary.MissingParamError('parentId');

              case 4:
                tag.type = _tagType.tagType.tag;
                _context.next = 7;
                return this._makeRequest('POST', null, tag, tag.region);

              case 7:
                return _context.abrupt("return", _context.sent);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createTag(_x) {
        return _createTag.apply(this, arguments);
      }

      return createTag;
    }()
    /**
     * Creates a new category
     * @param {string} body.text text of category
     * @param {string} body.parentId Id of category parent of tag (if applicable)
     *    * @param {string} body.description optional descriptive body
     * @throws {TagDoesNotExistError} when try to delete.
      * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise<UserSubscription>} the user subscription object
     */

  }, {
    key: "createCategory",
    value: function () {
      var _createCategory = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(tag) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (tag.text) {
                  _context2.next = 2;
                  break;
                }

                throw new _clientLibrary.MissingParamError('text');

              case 2:
                tag.type = _tagType.tagType.category;
                _context2.next = 5;
                return this._makeRequest('POST', null, tag, tag.region);

              case 5:
                return _context2.abrupt("return", _context2.sent);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createCategory(_x2) {
        return _createCategory.apply(this, arguments);
      }

      return createCategory;
    }()
    /**
     * Delete a tag or category
     *
     * @throws {TagDoesNotExistError} when try to delete tag that does not exist
     * @throws {TagHasChildrenError} when try to delete tag that has child tags
     * @throws {CoursesWithTagError} when try to delete tag that has been added to courses
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     */

  }, {
    key: "deleteTag",
    value: function () {
      var _deleteTag = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(tagId, type) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (tagId) {
                  _context3.next = 2;
                  break;
                }

                throw new _clientLibrary.MissingParamError('tagId');

              case 2:
                if (type) {
                  _context3.next = 4;
                  break;
                }

                throw new _clientLibrary.MissingParamError('type');

              case 4:
                _context3.next = 6;
                return this._makeRequest('DELETE', tagId, {
                  type: type
                });

              case 6:
                return _context3.abrupt("return", _context3.sent);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteTag(_x3, _x4) {
        return _deleteTag.apply(this, arguments);
      }

      return deleteTag;
    }()
    /**
     * Update a tag or category
     *
     * @throws {TagDoesNotExistError} when try to update tag that does not exist
     * @throws {CoursesWithTagError} when try to update tag that has been added to courses
     * @throws {NumberOfTagChildrenCannotBeAlteredError} when try to add or delete child tags through this method
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     */

  }, {
    key: "updateTag",
    value: function () {
      var _updateTag = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(tagId, tag) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (tagId) {
                  _context4.next = 2;
                  break;
                }

                throw new _clientLibrary.MissingParamError('tagId');

              case 2:
                if (tag.type) {
                  _context4.next = 4;
                  break;
                }

                throw new _clientLibrary.MissingParamError('type');

              case 4:
                _context4.next = 6;
                return this._makeRequest('PATCH', tagId, tag);

              case 6:
                return _context4.abrupt("return", _context4.sent);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateTag(_x5, _x6) {
        return _updateTag.apply(this, arguments);
      }

      return updateTag;
    }()
    /**
     * Fetch all tags and categories in a flat structure
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Array<Tags>} returns an array of tags (consisting of both tag and category types)
     */

  }, {
    key: "fetchAll",
    value: function () {
      var _fetchAll = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var options,
            items,
            lastKey,
            page,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
                items = [];
                lastKey = undefined;

              case 3:
                _context5.next = 5;
                return this.fetchPageOfTags({
                  limit: options.limit,
                  lastKey: lastKey,
                  region: options.region
                });

              case 5:
                page = _context5.sent;
                lastKey = page.lastKey;
                items = items.concat(page.tags);

              case 8:
                if (lastKey) {
                  _context5.next = 3;
                  break;
                }

              case 9:
                return _context5.abrupt("return", {
                  tags: items,
                  count: items.length
                });

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchAll() {
        return _fetchAll.apply(this, arguments);
      }

      return fetchAll;
    }()
  }, {
    key: "fetchPageOfTags",
    value: function () {
      var _fetchPageOfTags = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(options) {
        var queryParamsParts, limit, queryParams, url, requestOpts, response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                queryParamsParts = [];
                limit = 100;

                if (options && options.limit) {
                  limit = options.limit;
                }

                queryParamsParts.push("limit=".concat(limit));

                if (options && options.lastKey) {
                  queryParamsParts.push("lastKey=".concat(encodeURIComponent(options.lastKey)));
                }

                queryParams = queryParamsParts.join('&');
                url = "".concat(this.url, "/api/tags");
                url = queryParams.length > 0 ? "".concat(url, "?").concat(queryParams) : url;
                requestOpts = {
                  method: 'GET'
                };

                if (options.region) {
                  requestOpts.region = options.region;
                }

                _context6.next = 12;
                return this.requestMaker.makeRequest(url, requestOpts, [200, 400]);

              case 12:
                response = _context6.sent;

                if (!(response.status === 200)) {
                  _context6.next = 15;
                  break;
                }

                return _context6.abrupt("return", response.json);

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function fetchPageOfTags(_x7) {
        return _fetchPageOfTags.apply(this, arguments);
      }

      return fetchPageOfTags;
    }()
  }, {
    key: "_makeRequest",
    value: function () {
      var _makeRequest2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(method, id, body, region) {
        var url, expectedResponses, options, response, errorName;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                url = "".concat(this.url, "/api/tags");

                if (id) {
                  url += "/".concat(id);
                }

                expectedResponses = [200, 201, 204, 400, 404, 422];
                options = {
                  method: method,
                  body: body ? JSON.stringify(body) : undefined
                };

                if (region) {
                  options.region;
                }

                _context7.next = 7;
                return this.requestMaker.makeRequest(url, options, expectedResponses);

              case 7:
                response = _context7.sent;

                if (!(response.status === 404 && !response.text)) {
                  _context7.next = 10;
                  break;
                }

                throw new _NotFoundError2.default(id);

              case 10:
                // Backwards for PR https://github.com/SenecaLabs/tagsService/pull/42
                // actually createTag.test.js => "failureNoParent" test still relies on response.text
                errorName = response.json && response.json.reason || response.text;

                if (!_errorMapping2.default[errorName]) {
                  _context7.next = 13;
                  break;
                }

                throw new _errorMapping2.default[errorName]();

              case 13:
                return _context7.abrupt("return", response.json);

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _makeRequest(_x8, _x9, _x10, _x11) {
        return _makeRequest2.apply(this, arguments);
      }

      return _makeRequest;
    }()
  }]);

  return TagsServiceClient;
}(_clientLibrary.Client);

exports.default = TagsServiceClient;